/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CopropertyDto } from './CopropertyDto';
import {
    CopropertyDtoFromJSON,
    CopropertyDtoFromJSONTyped,
    CopropertyDtoToJSON,
    CopropertyDtoToJSONTyped,
} from './CopropertyDto';
import type { ContractualizationPricingDto } from './ContractualizationPricingDto';
import {
    ContractualizationPricingDtoFromJSON,
    ContractualizationPricingDtoFromJSONTyped,
    ContractualizationPricingDtoToJSON,
    ContractualizationPricingDtoToJSONTyped,
} from './ContractualizationPricingDto';
import type { PersonDto } from './PersonDto';
import {
    PersonDtoFromJSON,
    PersonDtoFromJSONTyped,
    PersonDtoToJSON,
    PersonDtoToJSONTyped,
} from './PersonDto';
import type { ContractTenant } from './ContractTenant';
import {
    ContractTenantFromJSON,
    ContractTenantFromJSONTyped,
    ContractTenantToJSON,
    ContractTenantToJSONTyped,
} from './ContractTenant';
import type { QuestionAnswerDto } from './QuestionAnswerDto';
import {
    QuestionAnswerDtoFromJSON,
    QuestionAnswerDtoFromJSONTyped,
    QuestionAnswerDtoToJSON,
    QuestionAnswerDtoToJSONTyped,
} from './QuestionAnswerDto';
import type { ContractInsured } from './ContractInsured';
import {
    ContractInsuredFromJSON,
    ContractInsuredFromJSONTyped,
    ContractInsuredToJSON,
    ContractInsuredToJSONTyped,
} from './ContractInsured';
import type { CabinetMandateDto } from './CabinetMandateDto';
import {
    CabinetMandateDtoFromJSON,
    CabinetMandateDtoFromJSONTyped,
    CabinetMandateDtoToJSON,
    CabinetMandateDtoToJSONTyped,
} from './CabinetMandateDto';
import type { GetRealEstateResponseDto } from './GetRealEstateResponseDto';
import {
    GetRealEstateResponseDtoFromJSON,
    GetRealEstateResponseDtoFromJSONTyped,
    GetRealEstateResponseDtoToJSON,
    GetRealEstateResponseDtoToJSONTyped,
} from './GetRealEstateResponseDto';
import type { ContractualizationParcDto } from './ContractualizationParcDto';
import {
    ContractualizationParcDtoFromJSON,
    ContractualizationParcDtoFromJSONTyped,
    ContractualizationParcDtoToJSON,
    ContractualizationParcDtoToJSONTyped,
} from './ContractualizationParcDto';
import type { QuoteTabDto } from './QuoteTabDto';
import {
    QuoteTabDtoFromJSON,
    QuoteTabDtoFromJSONTyped,
    QuoteTabDtoToJSON,
    QuoteTabDtoToJSONTyped,
} from './QuoteTabDto';
import type { Permissions } from './Permissions';
import {
    PermissionsFromJSON,
    PermissionsFromJSONTyped,
    PermissionsToJSON,
    PermissionsToJSONTyped,
} from './Permissions';
import type { CardStatuses } from './CardStatuses';
import {
    CardStatusesFromJSON,
    CardStatusesFromJSONTyped,
    CardStatusesToJSON,
    CardStatusesToJSONTyped,
} from './CardStatuses';
import type { EtatValidationDevis } from './EtatValidationDevis';
import {
    EtatValidationDevisFromJSON,
    EtatValidationDevisFromJSONTyped,
    EtatValidationDevisToJSON,
    EtatValidationDevisToJSONTyped,
} from './EtatValidationDevis';
import type { ParcRealEstateTenantsDto } from './ParcRealEstateTenantsDto';
import {
    ParcRealEstateTenantsDtoFromJSON,
    ParcRealEstateTenantsDtoFromJSONTyped,
    ParcRealEstateTenantsDtoToJSON,
    ParcRealEstateTenantsDtoToJSONTyped,
} from './ParcRealEstateTenantsDto';
import type { DisabledReasons } from './DisabledReasons';
import {
    DisabledReasonsFromJSON,
    DisabledReasonsFromJSONTyped,
    DisabledReasonsToJSON,
    DisabledReasonsToJSONTyped,
} from './DisabledReasons';

/**
 * 
 * @export
 * @interface ContractualizationResponseDto
 */
export interface ContractualizationResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof ContractualizationResponseDto
     */
    isAnimationCompleted?: boolean;
    /**
     * Unique identifier of the quote
     * @type {string}
     * @memberof ContractualizationResponseDto
     */
    quoteId: string;
    /**
     * Unique identifier of the tunnel/funnel
     * @type {string}
     * @memberof ContractualizationResponseDto
     */
    tunnelId?: string;
    /**
     * Human-readable folder identifier (optional, may come from parent response)
     * @type {string}
     * @memberof ContractualizationResponseDto
     */
    folderIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractualizationResponseDto
     */
    groupContractIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractualizationResponseDto
     */
    productOwner: string;
    /**
     * Code de la branche d'assurance
     * @type {string}
     * @memberof ContractualizationResponseDto
     */
    branchCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContractualizationResponseDto
     */
    isMaster: boolean;
    /**
     * 
     * @type {ContractInsured}
     * @memberof ContractualizationResponseDto
     */
    insured: ContractInsured;
    /**
     * Unique identifier of the simulation (optional, may come from parent response)
     * @type {string}
     * @memberof ContractualizationResponseDto
     */
    riskId?: string;
    /**
     * Status code of the contract (kept for debug/logs)
     * @type {string}
     * @memberof ContractualizationResponseDto
     */
    statusCode: string;
    /**
     * Unique identifier of the mandate if available (needed for API calls)
     * @type {string}
     * @memberof ContractualizationResponseDto
     */
    mandateId?: string | null;
    /**
     * List of quote tabs
     * @type {Array<QuoteTabDto>}
     * @memberof ContractualizationResponseDto
     */
    quoteTabs: Array<QuoteTabDto>;
    /**
     * 
     * @type {ContractualizationPricingDto}
     * @memberof ContractualizationResponseDto
     */
    pricing?: ContractualizationPricingDto;
    /**
     * Catégorie du statut de la quote.
     * Mapping depuis statusCode:
     * - Draft: 'E', 'EV', 'B' (and any unknown code)
     * - Accepted: 'AC'
     * - Cancelled: 'AB', 'RCL', 'HD'
     * 
     * @type {string}
     * @memberof ContractualizationResponseDto
     */
    statusCategory: ContractualizationResponseDtoStatusCategoryEnum;
    /**
     * Sévérité du statut pour l'affichage UI.
     * - Critical: Action requise (rouge)
     * - Warning: En cours de traitement (jaune)
     * - Success: Validé/Complété (vert)
     * - Neutral: État par défaut (gris)
     * 
     * @type {string}
     * @memberof ContractualizationResponseDto
     */
    statusSeverity: ContractualizationResponseDtoStatusSeverityEnum;
    /**
     * Statut de signature du contrat.
     * - Signed: Document BulletinAdhesionSigne existe
     * - WaitingSignature: Document BulletinAdhesion existe OU contrat envoyé
     * - ToSign: Aucun document de contrat
     * 
     * @type {string}
     * @memberof ContractualizationResponseDto
     */
    contractSignatureStatus: ContractualizationResponseDtoContractSignatureStatusEnum;
    /**
     * Statut de signature du mandat SEPA.
     * null si SEPA non activé (pas de mandat requis).
     * 
     * @type {string}
     * @memberof ContractualizationResponseDto
     */
    mandateSignatureStatus?: ContractualizationResponseDtoMandateSignatureStatusEnum | null;
    /**
     * Vrai si ce devis porte son propre mandat SEPA, et donc si l'étape mandat
     * (compte à débiter, envoi en signature, indicateur de signature) doit être présentée.
     * Toujours vrai hors contrat collectif. Pour un aliment, dépend du paramétrage du cadre :
     * faux quand le souscripteur règle pour tous — le mandat est alors porté par le cadre.
     * Optionnel : absent tant qu'un environnement n'est pas redéployé, traiter l'absence
     * comme « inconnu » et non comme « faux ».
     * 
     * @type {boolean}
     * @memberof ContractualizationResponseDto
     */
    requiresOwnMandate?: boolean;
    /**
     * Indique si le certificat d'adhésion existe
     * @type {boolean}
     * @memberof ContractualizationResponseDto
     */
    hasCertificate: boolean;
    /**
     * 
     * @type {CardStatuses}
     * @memberof ContractualizationResponseDto
     */
    cardStatuses: CardStatuses;
    /**
     * 
     * @type {Permissions}
     * @memberof ContractualizationResponseDto
     */
    permissions: Permissions;
    /**
     * 
     * @type {DisabledReasons}
     * @memberof ContractualizationResponseDto
     */
    disabledReasons?: DisabledReasons;
    /**
     * 
     * @type {CabinetMandateDto}
     * @memberof ContractualizationResponseDto
     */
    cabinetMandate?: CabinetMandateDto;
    /**
     * Quote validation state (validation requests to the validators of the tunnel).
     * @type {EtatValidationDevis}
     * @memberof ContractualizationResponseDto
     */
    validation?: EtatValidationDevis | null;
    /**
     * List of tenants (specific to GLI branch)
     * @type {Array<ContractTenant>}
     * @memberof ContractualizationResponseDto
     */
    tenants?: Array<ContractTenant>;
    /**
     * 
     * @type {GetRealEstateResponseDto}
     * @memberof ContractualizationResponseDto
     */
    realEstate?: GetRealEstateResponseDto;
    /**
     * Indicates if property information is complete (specific to GLI & CBNO branches)
     * @type {boolean}
     * @memberof ContractualizationResponseDto
     */
    propertyCompleted?: boolean | null;
    /**
     * 
     * @type {ContractualizationParcDto}
     * @memberof ContractualizationResponseDto
     */
    parc?: ContractualizationParcDto;
    /**
     * GLI parc uniquement — biens couverts avec leurs locataires et leur dossier documentaire (tenants reste vide dans ce mode)
     * @type {Array<ParcRealEstateTenantsDto>}
     * @memberof ContractualizationResponseDto
     */
    parcRealEstates?: Array<ParcRealEstateTenantsDto>;
    /**
     * MRI — copropriété rattachée au risque
     * @type {string}
     * @memberof ContractualizationResponseDto
     */
    copropertyId?: string | null;
    /**
     * MRI — copropriété assurée (fiche, bâtiments, compléments, sinistralité)
     * @type {CopropertyDto}
     * @memberof ContractualizationResponseDto
     */
    coproperty?: CopropertyDto | null;
    /**
     * MRI — copropriété complète et éligible (fiche + bâtiments + questionnaire COPRO_MRI)
     * @type {boolean}
     * @memberof ContractualizationResponseDto
     */
    copropertyCompleted?: boolean | null;
    /**
     * MRI — sinistralité exigible à la contractualisation (relevé d'information déposé si des sinistres sont déclarés, les deux engagements du souscripteur sinon)
     * @type {boolean}
     * @memberof ContractualizationResponseDto
     */
    copropertyClaimsHistoryCompleted?: boolean | null;
    /**
     * MRI — la copropriété porte au moins un sinistre déclaré, c'est alors le relevé d'information qui est attendu et non les engagements
     * @type {boolean}
     * @memberof ContractualizationResponseDto
     */
    copropertyClaimsDocumentRequired?: boolean | null;
    /**
     * MRI — réponses au questionnaire COPRO_MRI de la copropriété, rejouées par le sous-panneau de la contractualisation
     * @type {Array<QuestionAnswerDto>}
     * @memberof ContractualizationResponseDto
     */
    surveyAnswers?: Array<QuestionAnswerDto> | null;
    /**
     * PJ — société couverte (souscripteur principal du dossier), affichée par le panneau « risque » de la contractualisation
     * @type {PersonDto}
     * @memberof ContractualizationResponseDto
     */
    company?: PersonDto | null;
}


/**
 * @export
 */
export const ContractualizationResponseDtoStatusCategoryEnum = {
    Draft: 'Draft',
    Accepted: 'Accepted',
    Cancelled: 'Cancelled'
} as const;
export type ContractualizationResponseDtoStatusCategoryEnum = typeof ContractualizationResponseDtoStatusCategoryEnum[keyof typeof ContractualizationResponseDtoStatusCategoryEnum];

/**
 * @export
 */
export const ContractualizationResponseDtoStatusSeverityEnum = {
    Critical: 'Critical',
    Warning: 'Warning',
    Success: 'Success',
    Neutral: 'Neutral'
} as const;
export type ContractualizationResponseDtoStatusSeverityEnum = typeof ContractualizationResponseDtoStatusSeverityEnum[keyof typeof ContractualizationResponseDtoStatusSeverityEnum];

/**
 * @export
 */
export const ContractualizationResponseDtoContractSignatureStatusEnum = {
    ToSign: 'ToSign',
    WaitingSignature: 'WaitingSignature',
    Signed: 'Signed'
} as const;
export type ContractualizationResponseDtoContractSignatureStatusEnum = typeof ContractualizationResponseDtoContractSignatureStatusEnum[keyof typeof ContractualizationResponseDtoContractSignatureStatusEnum];

/**
 * @export
 */
export const ContractualizationResponseDtoMandateSignatureStatusEnum = {
    ToSign: 'ToSign',
    WaitingSignature: 'WaitingSignature',
    Signed: 'Signed'
} as const;
export type ContractualizationResponseDtoMandateSignatureStatusEnum = typeof ContractualizationResponseDtoMandateSignatureStatusEnum[keyof typeof ContractualizationResponseDtoMandateSignatureStatusEnum];


/**
 * Check if a given object implements the ContractualizationResponseDto interface.
 */
export function instanceOfContractualizationResponseDto(value: object): value is ContractualizationResponseDto {
    if (!('quoteId' in value) || value['quoteId'] === undefined) return false;
    if (!('productOwner' in value) || value['productOwner'] === undefined) return false;
    if (!('isMaster' in value) || value['isMaster'] === undefined) return false;
    if (!('insured' in value) || value['insured'] === undefined) return false;
    if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
    if (!('quoteTabs' in value) || value['quoteTabs'] === undefined) return false;
    if (!('statusCategory' in value) || value['statusCategory'] === undefined) return false;
    if (!('statusSeverity' in value) || value['statusSeverity'] === undefined) return false;
    if (!('contractSignatureStatus' in value) || value['contractSignatureStatus'] === undefined) return false;
    if (!('hasCertificate' in value) || value['hasCertificate'] === undefined) return false;
    if (!('cardStatuses' in value) || value['cardStatuses'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    return true;
}

export function ContractualizationResponseDtoFromJSON(json: any): ContractualizationResponseDto {
    return ContractualizationResponseDtoFromJSONTyped(json, false);
}

export function ContractualizationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractualizationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isAnimationCompleted': json['isAnimationCompleted'] == null ? undefined : json['isAnimationCompleted'],
        'quoteId': json['quoteId'],
        'tunnelId': json['tunnelId'] == null ? undefined : json['tunnelId'],
        'folderIdentifier': json['folderIdentifier'] == null ? undefined : json['folderIdentifier'],
        'groupContractIdentifier': json['groupContractIdentifier'] == null ? undefined : json['groupContractIdentifier'],
        'productOwner': json['productOwner'],
        'branchCode': json['branchCode'] == null ? undefined : json['branchCode'],
        'isMaster': json['isMaster'],
        'insured': ContractInsuredFromJSON(json['insured']),
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
        'statusCode': json['statusCode'],
        'mandateId': json['mandateId'] == null ? undefined : json['mandateId'],
        'quoteTabs': ((json['quoteTabs'] as Array<any>).map(QuoteTabDtoFromJSON)),
        'pricing': json['pricing'] == null ? undefined : ContractualizationPricingDtoFromJSON(json['pricing']),
        'statusCategory': json['statusCategory'],
        'statusSeverity': json['statusSeverity'],
        'contractSignatureStatus': json['contractSignatureStatus'],
        'mandateSignatureStatus': json['mandateSignatureStatus'] == null ? undefined : json['mandateSignatureStatus'],
        'requiresOwnMandate': json['requiresOwnMandate'] == null ? undefined : json['requiresOwnMandate'],
        'hasCertificate': json['hasCertificate'],
        'cardStatuses': CardStatusesFromJSON(json['cardStatuses']),
        'permissions': PermissionsFromJSON(json['permissions']),
        'disabledReasons': json['disabledReasons'] == null ? undefined : DisabledReasonsFromJSON(json['disabledReasons']),
        'cabinetMandate': json['cabinetMandate'] == null ? undefined : CabinetMandateDtoFromJSON(json['cabinetMandate']),
        'validation': json['validation'] == null ? undefined : EtatValidationDevisFromJSON(json['validation']),
        'tenants': json['tenants'] == null ? undefined : ((json['tenants'] as Array<any>).map(ContractTenantFromJSON)),
        'realEstate': json['realEstate'] == null ? undefined : GetRealEstateResponseDtoFromJSON(json['realEstate']),
        'propertyCompleted': json['propertyCompleted'] == null ? undefined : json['propertyCompleted'],
        'parc': json['parc'] == null ? undefined : ContractualizationParcDtoFromJSON(json['parc']),
        'parcRealEstates': json['parcRealEstates'] == null ? undefined : ((json['parcRealEstates'] as Array<any>).map(ParcRealEstateTenantsDtoFromJSON)),
        'copropertyId': json['copropertyId'] == null ? undefined : json['copropertyId'],
        'coproperty': json['coproperty'] == null ? undefined : CopropertyDtoFromJSON(json['coproperty']),
        'copropertyCompleted': json['copropertyCompleted'] == null ? undefined : json['copropertyCompleted'],
        'copropertyClaimsHistoryCompleted': json['copropertyClaimsHistoryCompleted'] == null ? undefined : json['copropertyClaimsHistoryCompleted'],
        'copropertyClaimsDocumentRequired': json['copropertyClaimsDocumentRequired'] == null ? undefined : json['copropertyClaimsDocumentRequired'],
        'surveyAnswers': json['surveyAnswers'] == null ? undefined : ((json['surveyAnswers'] as Array<any>).map(QuestionAnswerDtoFromJSON)),
        'company': json['company'] == null ? undefined : PersonDtoFromJSON(json['company']),
    };
}

export function ContractualizationResponseDtoToJSON(json: any): ContractualizationResponseDto {
    return ContractualizationResponseDtoToJSONTyped(json, false);
}

export function ContractualizationResponseDtoToJSONTyped(value?: ContractualizationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isAnimationCompleted': value['isAnimationCompleted'],
        'quoteId': value['quoteId'],
        'tunnelId': value['tunnelId'],
        'folderIdentifier': value['folderIdentifier'],
        'groupContractIdentifier': value['groupContractIdentifier'],
        'productOwner': value['productOwner'],
        'branchCode': value['branchCode'],
        'isMaster': value['isMaster'],
        'insured': ContractInsuredToJSON(value['insured']),
        'riskId': value['riskId'],
        'statusCode': value['statusCode'],
        'mandateId': value['mandateId'],
        'quoteTabs': ((value['quoteTabs'] as Array<any>).map(QuoteTabDtoToJSON)),
        'pricing': ContractualizationPricingDtoToJSON(value['pricing']),
        'statusCategory': value['statusCategory'],
        'statusSeverity': value['statusSeverity'],
        'contractSignatureStatus': value['contractSignatureStatus'],
        'mandateSignatureStatus': value['mandateSignatureStatus'],
        'requiresOwnMandate': value['requiresOwnMandate'],
        'hasCertificate': value['hasCertificate'],
        'cardStatuses': CardStatusesToJSON(value['cardStatuses']),
        'permissions': PermissionsToJSON(value['permissions']),
        'disabledReasons': DisabledReasonsToJSON(value['disabledReasons']),
        'cabinetMandate': CabinetMandateDtoToJSON(value['cabinetMandate']),
        'validation': EtatValidationDevisToJSON(value['validation']),
        'tenants': value['tenants'] == null ? undefined : ((value['tenants'] as Array<any>).map(ContractTenantToJSON)),
        'realEstate': GetRealEstateResponseDtoToJSON(value['realEstate']),
        'propertyCompleted': value['propertyCompleted'],
        'parc': ContractualizationParcDtoToJSON(value['parc']),
        'parcRealEstates': value['parcRealEstates'] == null ? undefined : ((value['parcRealEstates'] as Array<any>).map(ParcRealEstateTenantsDtoToJSON)),
        'copropertyId': value['copropertyId'],
        'coproperty': CopropertyDtoToJSON(value['coproperty']),
        'copropertyCompleted': value['copropertyCompleted'],
        'copropertyClaimsHistoryCompleted': value['copropertyClaimsHistoryCompleted'],
        'copropertyClaimsDocumentRequired': value['copropertyClaimsDocumentRequired'],
        'surveyAnswers': value['surveyAnswers'] == null ? undefined : ((value['surveyAnswers'] as Array<any>).map(QuestionAnswerDtoToJSON)),
        'company': PersonDtoToJSON(value['company']),
    };
}

